// extracted by mini-css-extract-plugin
export default {"titleWithBreadcrumbs":"titleWithBreadcrumbs_titleWithBreadcrumbs__Y2nso","title":"titleWithBreadcrumbs_title__9NyS7","breadcrumbs":"titleWithBreadcrumbs_breadcrumbs__Gd6-I"};